import { render } from "./ClusterWizardItem.vue?vue&type=template&id=5a46bd00&ts=true"
import script from "./ClusterWizardItem.vue?vue&type=script&lang=ts"
export * from "./ClusterWizardItem.vue?vue&type=script&lang=ts"

import "./ClusterWizardItem.vue?vue&type=style&index=0&id=5a46bd00&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__